import { Trans, useLingui } from '@lingui/react'
import { type Dispatch, type ReactElement, type SetStateAction } from 'react'

import { type PageType } from 'types/cmsTypes'
import { type Tenant } from 'types/shopConfig'
import Image from 'views/components/atoms/Image'
import Modal from 'views/components/molecules/Modal'
import nowLogo from 'views/components/organisms/Cart/NowCollapsible/now_logo.svg'
import './NowZipModalGreenVariant.scss'
import NowGlbZipModalForm from 'views/components/organisms/NowGlbZipModalForm'

interface INowZipModalGreenVariantProps {
  id: string
  open: boolean
  setModalOpen: Dispatch<SetStateAction<boolean>>
  zip: string
  pageType: PageType
  tenant: Tenant
}

const NowZipModalGreenVariant: (
  props: INowZipModalGreenVariantProps
) => ReactElement = ({ id, open, setModalOpen, zip, pageType, tenant }) => {
  const { i18n } = useLingui()

  return (
    <>
      {open ? (
        <Modal
          id={id}
          title={i18n._('general.label.nowGlobalBar.chooseLocation')}
          size="medium"
          light
          open={open}
          isClientSideControlled
          onHideModal={() => {
            setModalOpen(false)
          }}
        >
          <div>
            <div>
              <Trans id="general.label.nowGlobalBar.modalDescription" />
            </div>
            <div className="o-NowZipModalGreenVariant-NowInformationWrapper">
              <div className="o-NowZipModalGreenVariant-NowInformationWrapperTitle">
                <Image
                  className="u-margin--small u-padding-small--right o-NowGlobalBarContentGreenVariant__nowLogo"
                  src={nowLogo}
                />
                <strong>
                  <Trans id="general.label.nowGlobalBar.nowAvailability" />
                </strong>
              </div>
              <div>
                <Trans id="general.label.nowGlobalBar.nowAvailabilityDescription" />
              </div>
            </div>
            <div>
              <Trans id="general.label.nowGlobalBar.enterZip" />
            </div>
          </div>
          <NowGlbZipModalForm
            open={open}
            i18n={i18n}
            setModalOpen={setModalOpen}
            zip={zip}
            pageType={pageType}
            tenant={tenant}
          />
        </Modal>
      ) : null}
    </>
  )
}

export default NowZipModalGreenVariant
